import React from "react";
import "./Banner.css";

function Banner() {
  return (
    <div className="banner">
      <div className="banner-wrapper">
        Until March 2023, new Model 3 and Model Y vehicles qualify for a $7,500
        federal tax credit for eligible buyers. 
        <a href="">
          <span> &nbsp Learn More</span>
        </a>
      </div>
    </div>
  );
}

export default Banner;
